jQuery(document).ready(function ($){
    const shareButtonContainer = $('.print-share');

    if (shareButtonContainer.length) {
        const fbShare = shareButtonContainer.find('.share__img-fb');

        if (fbShare) {
            const linkUrl = fbShare.attr('href');
            const encodedUrl = encodeURIComponent( linkUrl );
            const fbAppId = VetfondsJs.vetShopData.fbShareApppId;

            if ( linkUrl && fbAppId ) {
                const fbShareUrl = 'https://www.facebook.com/dialog/feed?app_id=' + fbAppId + '&display=popup&link=' + encodedUrl + '&redirect_uri=' + encodedUrl;
                fbShare.attr('href', fbShareUrl);
            }
        } else {
            console.warn('FB share button missing!');
        }
    }
});